/*
 This file is part of GNU Taler
 (C) 2026 Taler Systems S.A.

 GNU Taler is free software; you can redistribute it and/or modify it under the
 terms of the GNU General Public License as published by the Free Software
 Foundation; either version 3, or (at your option) any later version.
*/

import { AmountJson, Amounts } from "@gnu-taler/taler-util";

export type WithdrawalAmountValidation =
  | "zero"
  | "below-minimum"
  | "above-maximum";

export function validateWithdrawalAmount(
  amount: AmountJson,
  minimum: AmountJson | undefined,
  maximum: AmountJson | undefined,
): WithdrawalAmountValidation | undefined {
  if (Amounts.isZero(amount)) return "zero";
  if (minimum && Amounts.cmp(amount, minimum) < 0) return "below-minimum";
  if (maximum && Amounts.cmp(amount, maximum) > 0) return "above-maximum";
  return undefined;
}

export function maximumWithdrawalAmount(
  accountLimit: AmountJson & { negative: boolean; saturated: boolean },
  fee: AmountJson,
  configuredMaximum?: AmountJson,
): AmountJson {
  const zero = Amounts.zeroOfCurrency(accountLimit.currency);
  if (accountLimit.negative || accountLimit.saturated) return zero;
  const afterFee = Amounts.sub(accountLimit, fee);
  if (afterFee.saturated) return zero;
  if (
    configuredMaximum &&
    Amounts.cmp(configuredMaximum, afterFee.amount) < 0
  ) {
    return configuredMaximum;
  }
  return afterFee.amount;
}
